import axios from "axios";
import { authConfig, checkedData, portalApiBase as base } from "./portalApi";
import { lookupId, personName, read } from "../utilities/commercialTaskList";

const checked = (response) => checkedData(response, "Broker action request failed");

const isTrue = (value) => value === true || String(value).toLowerCase() === "true";

export const normalizeBrokerAction = (record) => {
    const deal = read(record, "deal", "relatedDeal", "dealName");
    const resolved = isTrue(read(record, "completed", "complete", "resolved"));
    return {
        id: String(read(record, "id") || ""),
        dealId: String(read(record, "dealId") || lookupId(deal) || ""),
        text: read(record, "actionRequired", "feedback", "text") || "",
        author: personName(record, "broker", "salesBroker", "salesPerson", "owner", "createdBy") || "Unknown",
        createdAt: read(record, "createdTime", "createdDate", "dateCreated", "dateSubmitted") || "",
        resolved,
        resolvedBy: resolved ? personName(record, "resolvedBy", "resolved_By") || "" : "",
        resolvedAt: resolved ? read(record, "resolvedTime", "dateResolved", "modifiedTime") || "" : "",
    };
};

export const normalizeBrokerActionsResponse = (data) => {
    if (Array.isArray(data)) return data.map(normalizeBrokerAction);
    const rows = read(data, "brokerActions", "commBrokerActions", "data");
    if (rows != null && rows !== data) return normalizeBrokerActionsResponse(rows);
    if (data == null || data === "") return [];
    throw new Error("Unexpected broker action response");
};

export const fetchBrokerActions = async (token, dealId) => {
    const response = await axios.get(`${base}/${dealId ? "commbrokeractions-by-deal" : "commbrokeractions"}`, {
        ...authConfig(token),
        ...(dealId ? { params: { dealId: String(dealId) } } : {}),
    });
    return normalizeBrokerActionsResponse(checked(response));
};

export const createBrokerAction = async ({ dealId, salesBrokerId, text }, token) => {
    const message = String(text || "").trim();
    if (!dealId || !salesBrokerId || !message) {
        throw new Error("A deal, logged-in broker and feedback text are required");
    }
    return checked(
        await axios.post(
            `${base}/create-commbrokeractions`,
            { DealId: String(dealId), SalesBrokerId: String(salesBrokerId), ActionRequired: message },
            authConfig(token)
        )
    );
};

export const resolveBrokerAction = async (id, resolvedById, token) => {
    if (!id || !resolvedById) throw new Error("A broker action and logged-in user are required");
    return checked(
        await axios.post(
            `${base}/update-commbrokeractions`,
            { id: String(id), Resolved_By: { id: String(resolvedById) }, Completed: true },
            authConfig(token)
        )
    );
};

export const summariseBrokerActions = (actions) => {
    const byDeal = {};
    (actions || []).forEach((action) => {
        if (!action.dealId) return;
        const entry = (byDeal[action.dealId] = byDeal[action.dealId] || {
            hasFeedback: true,
            unresolvedCount: 0,
            lastReceivedAt: null,
        });
        if (!action.resolved) entry.unresolvedCount += 1;
        const at = new Date(action.createdAt);
        if (!Number.isNaN(at.getTime()) && (!entry.lastReceivedAt || at > new Date(entry.lastReceivedAt))) {
            entry.lastReceivedAt = action.createdAt;
        }
    });
    return byDeal;
};
